/**
 * `/starters` (5 Oct): "New starters" lives under Access now (product owner),
 * so while the access front door is on the old address lands on the access
 * cases list filtered to New. Off, it is the New starters page as before.
 * `/starters/:caseId` stays the New starter's own page (its stage tracker).
 */

import { Navigate } from "react-router";

import { LoadingState } from "@/components/common";
import { StartersPage } from "@/features/starters";
import { useMe } from "@/lib/api";

export function StartersRoute() {
  const { data: me, isPending } = useMe();
  if (isPending) {
    return <LoadingState />;
  }
  if (me?.access_front_door === true) {
    return <Navigate to="/access?type=new" replace />;
  }
  return <StartersPage />;
}
